/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, createContext, useState, ReactChild, useContext, useCallback } from 'react';
import { Button, ButtonToolbar, Modal } from 'rsuite';
import CrossIcon from '../assets/icons/cancel.svg';
import CheckIcon from '../assets/icons/check.svg';

interface ModalContext {
  test?: string;
  setTest?: any;
  modalFunc?: any;
  modalArgs?: any;
  modalBody?: any;
  modalTitle?: any;
  open?: any;
  handleOpen?: any;
  handleClose?: any;
  handleSuccessClose?: any;
  setModalFunc?: any;
  setModalArgs?: any;
  setModalBody?: any;
  setModalTitle?: any;
  setOpen?: any;
}

const context = createContext<ModalContext>({});

const { Provider } = context;

interface Props {
  children: ReactChild | ReactChild[];
}

export const ModalProvider: FC<Props> = ({ children }) => {
  // const [test, setTest] = useState("5");

  type CallbackFunctionWithArgs = (...args: any[]) => void;

  const [modalFunc, setModalFunc] = useState<CallbackFunctionWithArgs>();
  const [modalArgs, setModalArgs] = useState();
  const [modalBody, setModalBody] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalOkButtonText, setModalOkButton] = useState('');
  const [modalCloseButton, setModalCloseButton] = useState('');
  const [reversedButton, setReversedButton] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = useCallback(
    (
      func: any,
      arg: any,
      body = 'آیا از تصمیم خود اطمینان دارید؟',
      title = '',
      okButton = 'بلی',
      closeButton = 'خیر',
      reversed = false
    ) => {
      setModalFunc(func);
      setModalArgs(arg);
      setModalBody(body);
      setModalTitle(title);
      setModalOkButton(okButton);
      setModalCloseButton(closeButton);
      setReversedButton(reversed);
      setOpen(true);
    },
    []
  );
  const handleSuccessClose = useCallback(() => {
    setOpen(false);
    if (modalFunc) {
      console.log(modalFunc, modalArgs);
      modalFunc(modalArgs);
    }
  }, [modalFunc, modalArgs]);
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Provider
      value={{
        // test,
        // setTest,
        // modalFunc,
        // modalArgs,
        // modalBody,
        // modalTitle,
        open,
        handleOpen,
        handleClose,
        handleSuccessClose,
        // setModalFunc,
        // setModalArgs,
        // setModalBody,
        // setModalTitle,
        setOpen
      }}>
      {children}
      <Modal open={open} onClose={handleClose} size="xs">
        <Modal.Header className="">
          <Modal.Title className="py-2">{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-justify">{modalBody}</Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className="flex justify-between" style={{ flexDirection: 'column' }}>
            <Button
              onClick={reversedButton ? handleClose : handleSuccessClose}
              appearance="primary"
              className="btn-outline">
              <img src={CheckIcon} alt="" />
              {modalOkButtonText}
            </Button>
            <Button
              onClick={reversedButton ? handleSuccessClose : handleClose}
              appearance="default"
              className="btn-outline-error">
              <img src={CrossIcon} alt="" />
              {modalCloseButton}
            </Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    </Provider>
  );
};

export const useModal = () => useContext(context);
